import { cn } from '@/lib/utils'
import { memo } from 'react'

const Slide = ({
  children,
  className,
  style,
  ...props
}: {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  props?: React.HTMLAttributes<HTMLDivElement>
}) => (
  <div
    className={cn(
      'embla__slide group relative h-full min-w-0 flex-[0_0_var(--slide-size)] translate-0 pl-(--slide-spacing) transition-opacity duration-600 [&:not(.is-in-view)]:opacity-30',
      className
    )}
    style={style}
    {...props}
  >
    {children}
  </div>
)

Slide.displayName = 'Slide'

export default memo(Slide)
